import React, { useEffect, useState } from 'react';
import styles from './AdminLeagues.module.scss';
import { Box, Typography } from '@mui/material';
import LeagueList from '../../../components/admin/LeagueList/LeagueList';
import LeagueAddEdit from '../../../components/admin/LeagueAddEdit/LeagueAddEdit';
import { useDispatch } from 'react-redux';
import { leagueList } from '../../../redux/actions/app/leagueList';
import { useSelector } from 'react-redux';
const AdminLeagues = () => {
  const [actionModal, setActionModal] = useState(null);
  const [editLeague, setEditLeague] = useState();
  const dispatch = useDispatch();
  const {
    leagueList: { data: leagueListData, loading: leagueListDataLoading },
  } = useSelector((state) => state.app);
  useEffect(() => {
    dispatch(leagueList());
  }, []);
  console.log(leagueListData);

  return (
    <>
      <Box>
        <Typography variant="h5" sx={{ fontSize: '20px', fontWeight: '600', mb: 4 }}>
          Лиги
        </Typography>
        <Box sx={{ alignItems: 'start', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
          {' '}
          {leagueListData ? (
            <LeagueList
              editLeague={editLeague}
              onEdit={(val) => {
                setEditLeague(val);
                setActionModal('edit');
              }}
              onSubEdit={(val) => {
                setEditLeague(val);
                setActionModal('editChildren');
              }}
              onSubAdd={(val) => {
                setEditLeague(val);
                setActionModal('createChildren');
              }}
              onAdd={() => {
                setEditLeague(null);
                setActionModal('create');
              }}
            />
          ) : (
            <Box></Box>
          )}
          {actionModal ? (
            <LeagueAddEdit
              key={`${actionModal}_${editLeague?.id}`}
              league={editLeague}
              onClose={() => {
                setEditLeague(null);
                setActionModal(null);
              }}
              type={actionModal}
            />
          ) : (
            <Box></Box>
          )}
        </Box>
      </Box>
    </>
  );
};

export default AdminLeagues;
